import sharedMain from '@shared/app/main';
import mrsTheme from './app/theme/mrs.theme';

sharedMain(mrsTheme);
